import { __assign, __makeTemplateObject, __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import SvgIcon from '../Icons/SvgIcon';
var Circle = styled.circle.withConfig({
  displayName: "ui-kit-Circle",
  componentId: "ui-kit-12ggnav"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  stroke-dasharray: 80px, 200px;\n  stroke-dashoffset: 0px;\n  stroke: currentColor;\n  animation: circular-progress 1.4s ease-in-out infinite;\n\n  @keyframes circular-progress {\n    0% {\n      stroke-dasharray: 1px, 200px;\n      stroke-dashoffset: 0px;\n    }\n    50% {\n      stroke-dasharray: 100px, 200px;\n      stroke-dashoffset: -15px;\n    }\n    100% {\n      stroke-dasharray: 100px, 200px;\n      stroke-dashoffset: -125px;\n    }\n  }\n"], ["\n  stroke-dasharray: 80px, 200px;\n  stroke-dashoffset: 0px;\n  stroke: currentColor;\n  animation: circular-progress 1.4s ease-in-out infinite;\n\n  @keyframes circular-progress {\n    0% {\n      stroke-dasharray: 1px, 200px;\n      stroke-dashoffset: 0px;\n    }\n    50% {\n      stroke-dasharray: 100px, 200px;\n      stroke-dashoffset: -15px;\n    }\n    100% {\n      stroke-dasharray: 100px, 200px;\n      stroke-dashoffset: -125px;\n    }\n  }\n"])));

var LoaderIcon = function LoaderIcon(_a) {
  var _b = _a.width,
      width = _b === void 0 ? 44 : _b,
      _c = _a.height,
      height = _c === void 0 ? 44 : _c,
      className = _a.className,
      props = __rest(_a, ["width", "height", "className"]);

  return _jsx(SvgIcon, __assign({
    version: "1.1",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    x: "0px",
    y: "0px",
    width: width,
    height: height,
    viewBox: "22 22 44 44",
    className: className
  }, props, {
    children: _jsx(Circle, __assign({
      cx: "44",
      cy: "44",
      r: "20.2",
      strokeWidth: "3.6",
      fill: "none"
    }, {
      children: _jsx("animateTransform", {
        attributeType: "xml",
        attributeName: "transform",
        type: "rotate",
        from: "0 44 44",
        to: "360 44 44",
        dur: "1.4s",
        repeatCount: "indefinite"
      })
    }))
  }));
};

export default LoaderIcon;
var templateObject_1;